import {DateFormat} from "../../date_format"
import messageResource from "../../messageResource"
import OvertimeReportParametersFormatter from "../../reports/overtimeReport/ParametersFormatter"
import ChartPDFDateRangeFormattingStrategy from '../formatters/ChartPDFDateRangeFormattingStrategy'

export default class PDFParametersFormattingStrategy {
    init(config) {
        this.dateParametersFormattingStrategy = this.createDateParametersFormattingStrategy(config.dateFormat, config.dateFormatForFile);
        this.shortDateFormat = new DateFormat(window.SystemSettings.dateFormat);
        this.parametersFormatter = new OvertimeReportParametersFormatter().init({
            selectorsData: config,
            dateFormat: config.dateFormat,
        })

        return this;
    }

    createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
        return new ChartPDFDateRangeFormattingStrategy(dateFormat, dateFormatForFile)
    }

    formatChartPDFFilterInformation(selectedParameters) {
        return {
            firstRow: this.formatUsersSelection(selectedParameters)
        }
    }

    formatUsersSelection(selectedParameters) {
        return this.parametersFormatter.formatUsersSelection(selectedParameters.userSelection);
    }

    formatChartPDFHeaderDateInformation(selectedParameters) {
        return this.dateParametersFormattingStrategy.formatDateInformation(selectedParameters);
    }

    formatChartPDFFileName(selectedParameters) {
        var dateRange = selectedParameters.dateRangeSelection;
        var formattedDateRange = "(" + this.shortDateFormat.formatDate(dateRange.fromDate) + " - " + this.shortDateFormat.formatDate(dateRange.toDate) + ")";

        var fileNameParts = [];
        fileNameParts.push(this._makePDFTitle(selectedParameters, 'common_report.pdf.header.and'));
        fileNameParts.push(formattedDateRange);

        return messageResource.getMessage('common_report.pdf.file_name', fileNameParts);
    }

    _makePDFTitle(selectedParameters, andSubstitutionKey) {
        return OvertimeReportFormatUtils.makePDFTitle(selectedParameters, andSubstitutionKey)
    }

    formatChartPDFHeaderTitle(selectedParameters) {
        return messageResource.getMessage('common_report.pdf.header.report', [this._makePDFTitle(selectedParameters)]);
    }

    formatChartPDFReportTitle(selectedParameters) {
        var showBy = BaseReportFormatUtils.formatGroupingLevel(selectedParameters.firstGroupingLevel);
        return messageResource.getMessage('common_report.pdf.header.report_by', [this._makePDFTitle(selectedParameters), showBy]);
    }
}


// WEBPACK FOOTER //
// ./web/js/pdf/overtimeReport/PDFParametersFormattingStrategy.js